import TitleBox from "../../components/Common/TitleBox";
import ContractTemplateBoard from "../../components/ContractTemplate/ContractTemplateBoard";

function ContractTemplateMain() {
  return (
    <div>
      <TitleBox title="계약서 양식" />
      <ContractTemplateBoard />
    </div>
  );
}

export default ContractTemplateMain;
